import * as React from 'react';
const SvgFlow = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="send-01">
      <path
        id="Fill"
        opacity={0.12}
        d="M12.5923 3.13215C13.099 2.61431 13.3524 2.35539 13.4938 2.36017C13.6154 2.36429 13.7247 2.43724 13.7772 2.54941C13.8383 2.67982 13.708 3.02094 13.4475 3.70317L9.62047 13.7247C9.46897 14.1214 9.39322 14.3198 9.28434 14.3776C9.18995 14.4277 9.07757 14.4276 8.98324 14.3774C8.87442 14.3195 8.7989 14.121 8.64786 13.7241L6.8501 9.00007L12.5923 3.13215Z"
        fill="currentColor"
      />
      <path
        id="Icon"
        d="M6.85003 9.00012L13.7 2.00012M6.93327 9.21883L8.6478 13.7242C8.79884 14.1211 8.87436 14.3195 8.98318 14.3774C9.07751 14.4277 9.18988 14.4277 9.28427 14.3776C9.39316 14.3198 9.46891 14.1215 9.62041 13.7247L13.9198 2.46625C14.0566 2.10813 14.125 1.92907 14.0876 1.81465C14.0551 1.71528 13.9788 1.6373 13.8815 1.60411C13.7696 1.56588 13.5943 1.63576 13.2439 1.77552L2.22665 6.16908C1.83843 6.32389 1.64432 6.4013 1.58776 6.51257C1.53872 6.60903 1.53879 6.72386 1.58793 6.82026C1.64463 6.93146 1.83883 7.00864 2.22722 7.16299L6.63601 8.91506C6.71485 8.94639 6.75427 8.96206 6.78746 8.98625C6.81688 9.0077 6.84261 9.03399 6.8636 9.06406C6.88728 9.09798 6.90261 9.13826 6.93327 9.21883Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default SvgFlow;
